import { render, staticRenderFns } from "./FabMenu.vue?vue&type=template&id=271ec204&scoped=true&"
import script from "./FabMenu.vue?vue&type=script&lang=js&"
export * from "./FabMenu.vue?vue&type=script&lang=js&"
import style0 from "./FabMenu.vue?vue&type=style&index=0&id=271ec204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ec204",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VIcon,VSpeedDial,VTooltip})
